module.exports = __webpack_public_path__ + "static/img/定制服务图标.10c296a.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/定制服务图标.gif
// module id = B1Jb
// module chunks = 3